import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Badge, Card, CardContent, PageLoading } from "@dosa/ui";
import { listServices } from "../../lib/api-client";

export function AdminServicesPage() {
  const { t } = useTranslation();
  const { data: services, isLoading } = useQuery({ queryKey: ["services"], queryFn: listServices });

  if (isLoading) return <PageLoading />;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-charcoal-900">{t("admin.services.title")}</h1>
      <Card>
        <CardContent className="p-0">
          <ul className="divide-y divide-charcoal-100">
            {services?.map((s) => (
              <li key={s.id} className="flex items-center justify-between px-5 py-4">
                <div>
                  <p className="font-medium text-charcoal-800">{s.name}</p>
                  <p className="text-sm text-charcoal-400">
                    {s.durationMinutes} min &middot; {(s.priceMinorUnits / 100).toFixed(0)} {s.currency}
                  </p>
                </div>
                <Badge variant={s.isActive ? "success" : "neutral"}>{s.isActive ? "Active" : "Inactive"}</Badge>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
